// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card__title[data-v-21b2944a]{background-color:#165fd8;color:#fff}.price__title__underline[data-v-21b2944a]{border-bottom:6px solid #165fd8;width:15%;padding-top:16px;margin-left:62%}", ""]);
// Exports
module.exports = exports;
